import type { DateTimeFormatOptions } from "luxon";
import { DateTime } from "luxon";
import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { LOCAL_DATE_SETTINGS } from "../../../../utils/dates";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import type { ColumnDefinitionProps } from "./columns.types";

interface GetDateStartColumnProps<
  T extends MRT_RowData
> extends ColumnDefinitionProps<T> {
  DateTimeFormatOptions?: DateTimeFormatOptions;
}

function getDateStartColumn<T extends MRT_RowData>({
  key,
  options,
  DateTimeFormatOptions = LOCAL_DATE_SETTINGS
}: GetDateStartColumnProps<T>): MRT_ColumnDef<T> {
  return {
    id: key,
    header: "Zeitraum Start",
    accessorFn: (row) =>
      row?.[key]
        ? backendDateOrDateTimeToLuxonDateTime(row?.[key]).toJSDate()
        : undefined,
    filterVariant: "date",
    filterFn: (row, columnId, filterValue) => {
      const cellDate = DateTime.fromJSDate(row.getValue<Date>(columnId));
      if (!cellDate.isValid) return true;
      const startDate = DateTime.fromISO(filterValue || "1900-01-01");
      return cellDate >= startDate;
    },
    filterTooltipValueFn: (filterValue) =>
      filterValue
        ? `nach ${DateTime.fromISO(filterValue).toLocaleString(DateTimeFormatOptions)}`
        : "",
    Cell: ({ cell }) => {
      const date = cell.getValue<Date | undefined>();

      if (!date) {
        return null;
      }

      return DateTime.fromJSDate(date).toLocaleString(DateTimeFormatOptions);
    },
    ...options
  };
}

export { getDateStartColumn };
